import { render, staticRenderFns } from "./ChangeUsername.vue?vue&type=template&id=4bc9a67f&scoped=true&"
import script from "./ChangeUsername.vue?vue&type=script&lang=js&"
export * from "./ChangeUsername.vue?vue&type=script&lang=js&"
import style0 from "./ChangeUsername.vue?vue&type=style&index=0&id=4bc9a67f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc9a67f",
  null
  
)

export default component.exports